export default __webpack_public_path__ + "static/image 52-6897b78497ab5dc20def1e3506248c9d.png";